module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "COPYRIGHT"
  }, [_c('br'), _vm._v("Wm. B. Eerdmans Publishing Co."), _c('br'), _vm._v("2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /"), _c('br'), _vm._v("P.O. Box 163, Cambridge "), _c('span', {
    staticClass: "scall"
  }, [_vm._v("CB3 9PU")]), _vm._v(" U.K. "), _c('br'), _vm._v("www.eerdmans.com"), _c('br'), _c('br'), _vm._v("© 1996 N. T. Wright"), _c('br'), _vm._v("All rights reserved"), _c('br'), _vm._v("First U.K. edition published 1996 by"), _c('br'), _vm._v("Society for Promoting Christian Knowledge"), _c('br'), _vm._v("36 Causton Street, London "), _c('span', {
    staticClass: "scall"
  }, [_vm._v("SW1P 4ST")]), _c('br'), _vm._v("First American edition published 1997 by"), _c('br'), _vm._v("Wm. B. Eerdmans Publishing Co."), _c('br'), _vm._v("New edition published 2014"), _c('br'), _c('br'), _vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "LIBRARY"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("ISBN 978-0-8028-7177-0")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("eISBN 978-1-4674-2884-2 (ePub)")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("eISBN 978-1-4674-1156-1 (Kindle)")]), _vm._v(" "), _c('p', {
    staticClass: "URL"
  }, [_c('a', {
    attrs: {
      "href": "http://www.eerdmans.com",
      "target": "_blank"
    }
  }, [_vm._v("www.eerdmans.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23e4fede","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Copyright.vue
// module id = 60
// module chunks = 0